import api from 'api'
import { getWorkOrderListProvidesTags, getWorkOrderListSummaryProvidesTags } from 'components/customer-details/content/work-orders/utils'

import type { WorkOrderFacetsApi, WorkOrderFacetsRequestApi } from 'types/api/work-order/workOrderFacets'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    fetchWorkOrderFacets: build.query<WorkOrderFacetsApi, WorkOrderFacetsRequestApi>({
      query: body => ({ url: '/api/v1/core/work-orders/list/facets', method: 'POST', body }),
      // Summary tags too: this replaced /list/summary, and activate/deactivate still invalidate by those.
      providesTags: (result, error, body) => [...getWorkOrderListProvidesTags(body), ...getWorkOrderListSummaryProvidesTags(body)],
    }),
  }),
})

export const { useFetchWorkOrderFacetsQuery } = extendedApi
